module.exports = __webpack_public_path__ + "img/p-one-step-06.30cd6c9b.png";